import { render, staticRenderFns } from "./ProfessionalMaterialsPanel.vue?vue&type=template&id=5428ab8d&scoped=true&"
import script from "./ProfessionalMaterialsPanel.vue?vue&type=script&lang=js&"
export * from "./ProfessionalMaterialsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalMaterialsPanel.vue?vue&type=style&index=0&id=5428ab8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428ab8d",
  null
  
)

export default component.exports